import { Command } from 'commands/Commands';

export class MediaPublish extends Command {
  type: string = 'Media.Publish';
  priority: number = 150;
}

export class MediaApprove extends Command {
  type: string = 'Media.Approve';
  priority: number = 150;
}

export class MediaReject extends Command {
  type: string = 'Media.Reject';
  priority: number = 150;
}
